<template>
    <div>
        <section class="m-maptop">
            <a :href="listViewUrl + '?' + filterQuerystring" class="e-back" v-if="listViewUrl">Exit Map</a>

            <div class="e-actions">
                <search-filters :show-results-count="false"></search-filters>

                <!--<a href="#" class="btn btn-green property-alerts" v-if="isLoggedIn">Property alerts</a>-->
            </div>
        </section>
        <section class="m-mapview">
            <div class="e-iteminfo" :data-status="itemInfoStatus">
                <div class="close" v-on:click="toggleItemInfoStatus()">
                    <span>&times;</span>
                    Close
                </div>
                <template v-if="propertySummary">
                    <div class="e-iteminfo__panel">
                        <div>
                            <h3>
                                <a :href="propertySummary.Url">{{propertySummary.PropertyTitle}}</a>
                            </h3>
                            <div class="image">
                                <ul class="e-data">
                                    <li v-if="propertySummary.PropertyHasPhotos">{{propertySummary.PropertyPhotos.length}}</li>
                                    <li v-if="propertySummary.PropertyHasDocuments"><i class="fa fa-arrow-down" aria-hidden="true"></i></li>
                                    <li v-if="propertySummary.PropertyHasVideo"><i class="fa fa-play" aria-hidden="true"></i></li>
                                </ul>
                                <a :href="propertySummary.Url">
                                    <thumbnail-image :photo-id="propertySummary.PropertyPhotos[0].MediaItem.Id" v-if="propertySummary.PropertyPhotos && propertySummary.PropertyPhotos[0].MediaItem"></thumbnail-image>
                                </a>
                            </div>
                            <div class="text">
                                <p>
                                    {{truncate(propertySummary.PropertyDescription, 150)}}
                                </p>
                                <a :href="propertySummary.Url" class="btn btn-green">Find out more</a>
                                <profile-actions :page-id="propertySummary.Id.toString()"></profile-actions>
                            </div>
                            <div class="amount">
                                {{formatAskingPrice(propertySummary)}}
                            </div>
                        </div>
                    </div>
                </template>
            </div>
            <div id="mapContainer">
                <gmap-map ref="gmap"
                          :center="center"
                          :options="mapOptions"
                          style="width:100%;  height: 100%;"
                          :zoom="8">
                    <gmap-cluster :zoomOnClick="true" :maxZoom="18">
                        <gmap-marker @click="clickMarker(m.position, m.propertyId)"
                                     :icon="markerIcon"
                                     :key="index"
                                     :position="m.position"
                                     ref="marker"
                                     v-for="(m, index) in markers"></gmap-marker>
                    </gmap-cluster>
                </gmap-map>
            </div>
        </section>
    </div>
</template>

<script>
    import Axios from 'axios'
    import GmapCluster from 'vue2-google-maps/dist/components/cluster'
    import ProfileActions from '@/components/Utils/profile-actions'
    import SearchFilters from '@/components/SiteSearch/search-filters'
    import ThumbnailImage from '@/components/Utils/thumbnail-image'
    import Vue from 'vue'

    import { globalMixin } from '@/mixins/globalMixin.js'
    import { propertyMixin } from '@/mixins/propertyMixin.js'
    import { searchMixin } from '@/mixins/searchMixin.js'
    import { truncate } from '@/utils/strings.js'

    import * as VueGoogleMaps from 'vue2-google-maps'

    Vue.use(VueGoogleMaps, {
        load: {
            key: googleMapsApiKey
        }
    })

    Vue.component('gmap-cluster', VueGoogleMaps.Cluster)

    export default {
        components: {
            GmapCluster,
            ProfileActions,
            SearchFilters,
            ThumbnailImage
        },

        computed: {
            isLoggedIn: function () {
                return isLoggedIn
            },

            filterQuerystring: {
                get() {
                    return this.$store.getters.searchFiltersQuerystring(null, null, false)
                },
                set() {
                }
            },

            mapOptions: function () {
                return this.$store.state.mapOptions
            },

            markerIcon: function () {
                return this.$store.state.mapOptions.markerIcon
            },

            markers: function () {
                var vm = this

                return vm.$store.state.search.results && vm.$store.state.search.results.filter(x => x.Content && x.Content.PropertyLocation).map(x => {
                    return {
                        position: google && new google.maps.LatLng(x.Content.PropertyLocation.latitude + '' + vm._.random(1, 10), x.Content.PropertyLocation.longitude + '' + vm._.random(1, 10)),
                        propertyId: x.Id
                    }
                })
            }
        },

        created: function () {
            const vm = this

            vm.$store.dispatch('updateSearchFilter', { key: 'page', value: 1 })
            vm.$store.dispatch('updateSearchFilter', { key: 'showAllResults', value: true })

            vm.$eventHub.$on('search-filtersChanged', vm.onFiltersChanged)
        },

        data() {
            return {
                center: { lat: 57.4679769, lng: -4.2918971 },
                itemInfoStatus: 'closed',
                loading: true,
                mapLoaded: false,
                oms: null,
                propertySummary: null,
                searchApiUrl: '/umbraco/api/PropertySearchApi/Search'
            }
        },

        methods: {
            clickMarker: function (markerPosition, propertyId) {
                var vm = this
                vm.center = markerPosition
                vm.loading = true

                const getPropertySummary = function () {
                    return Axios.get(
                        '/umbraco/api/PropertySearchApi/Summary', {
                            params: {
                                propertyId: propertyId
                            }
                        }
                    )
                }

                Axios.all([getPropertySummary()])
                    .then(Axios.spread(function (response) {

                        if (response && response.data) {
                            vm.propertySummary = response.data
                            vm.itemInfoStatus = 'open'
                        }

                        vm.loading = false
                    }))
                    .catch(() => {
                        vm.loading = false
                    })
            },

            init: function () {
                this.search(true)
            },

            onFiltersChanged: function () {
                this.search(true)
            },

            toggleItemInfoStatus: function () {
                this.itemInfoStatus = this.itemInfoStatus == 'closed' ? 'open' : 'closed'
            },

            truncate: function (stringToTruncate) {
                return truncate(stringToTruncate)
            }
        },

        mounted: function () {
            const vm = this

            vm.$gmapApiPromiseLazy().then(() => {
                vm.init()

                vm.mapLoaded = true
            })
        },

        mixins: [globalMixin, propertyMixin, searchMixin],

        props: {
            listViewUrl: {
                type: String
            }
        }
    }
</script>